import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomizedSwitchBase = styled(Switch)(({ checked }) => ({
  width: 50,
  height: 32,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    "&.Mui-checked": {
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#D1D1D2",
        width: 50,
        height: 20,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: checked ? "#43425D" : "#A1A1A1",
    width: 24,
    height: 24,
    margin: 3,
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#D1D1D2",
    borderRadius: 20 / 2,
  },
}));

function SwitchBase({ changeHandler, checked }: any) {
  return <CustomizedSwitchBase checked={checked} onChange={changeHandler} />;
}

export default SwitchBase;
